export default __webpack_public_path__ + "assets/images/c590e198878d806f99f51992eb34f94f.png";